import MagicParticle, { MagicParticleOptions } from "./MagicParticle"

export type ManaSparkParticleOptions = {} & MagicParticleOptions

export default class ManaSparkParticle extends MagicParticle {

	static baseSize: 10

	constructor(options: ManaSparkParticleOptions) {
		super({
			...options,

			symbol: '✨',
			size: 10
		})

	}

	damage(amt: number) { }

	private disposed = false

	dispose() {
		if (!this.disposed) {
			super.dispose()
			this.disposed = true
		}
	}

}